import { Collection } from 'modules/core/lib/mobx-rest'

import CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

class CompanyHolidays extends Collection<CompanyHoliday> {
  get cacheKey(): string {
    return 'companyHolidays'
  }

  model() {
    return CompanyHoliday
  }
}

const singleton: CompanyHolidays = new CompanyHolidays()

export const locationHolidays = (locationId: string) => {
  return singleton.filter({
    location_id: locationId,
  })
}

export default singleton
